<script>
import Vue from "vue"
import Track from "../plugins/track"
Vue.use(Track)
export default {
  name: "tracker",
  props: ["a", "tn", "tr"],
  render: function () {
    return this.$slots.default;
  },
  mounted: function () {
    this.$track(this.a, this.tn, this.tr);
  },
}
</script>
